import { Injectable } from "@angular/core";

@Injectable()
export class AdminLocalStorageService {


    getToken(): any{
      //return JSON.parse(localStorage.getItem('awsToken'));
      return localStorage.getItem('awsToken')
    }

    deleteToken(): void {
      localStorage.removeItem('awsToken');
    }

    setToken(token: any) : void {
      localStorage.setItem('awsToken', token);
    }

    setAccessToken(token: any): void {
      localStorage.setItem('awsAccessToken', token);
    }

}
